/**
 * Learning Library preference (Tim, Aug 25 chat): an organization can include or exclude the
 * industry library (CSB case studies and documents other organizations shared) from what its
 * people see. Hiding it only hides content — scores, trends and warnings come from the
 * organization's own data, and what REPSit has already learned from those cases keeps working.
 *
 * Stored on the organization document as `library.includeIndustryLibrary` (default true).
 */
export function includesIndustryLibrary(org) {
  return org?.library?.includeIndustryLibrary !== false;
}

export const DEFAULT_LIBRARY_PREFS = Object.freeze({ includeIndustryLibrary: true });
